import { atom } from "jotai";
import { atomFamily } from "jotai/utils";
import { zslAtom } from "../templates";
import { extractAssetId, isTemplateChatbotId } from "../utils";
import { fetchChatbotAtomFamily_SUSPENDS } from "./fetchChatbotAtomFamily_SUSPENDS";

export const chatbotAtomFamily_SUSPENDS = atomFamily(
  (chatbotId: string | undefined) => {
    const baseAtom = atom(async (get) => {
      if (!chatbotId) {
        return;
      }

      const isTemplateChatbot = isTemplateChatbotId(chatbotId);
      const zsl = get(zslAtom);

      if (zsl && isTemplateChatbot) {
        const coreChatbotId = extractAssetId(chatbotId);

        const chatbotTemplate = zsl.chatbots?.find(
          (chatbot) => coreChatbotId === chatbot.id,
        );

        if (chatbotTemplate) {
          return {
            id: chatbotTemplate.id,
            name:
              chatbotTemplate.chatbotName || chatbotTemplate.config.chatbotName,
          };
        }
      }

      // If it's a template id but not present in zsl, avoid calling API which would 400
      if (isTemplateChatbot) {
        return;
      }

      // Delegate API retrieval to the shared fetch atom
      const chatbotResult = await get(
        fetchChatbotAtomFamily_SUSPENDS(chatbotId),
      );
      const isSuccess = chatbotResult?.type === "success";
      return isSuccess ? chatbotResult.data : null;
    });

    baseAtom.debugLabel = `chatbotAtomFamily_SUSPENDS(${chatbotId})`;
    return baseAtom;
  },
);
